export default "__VITE_ASSET__f529418f__"